import { IconButton, Tooltip } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useFullscreen } from 'src/contexts/fullscreenContext';

export const FullscreenToggleButton = () => {
  const { isFullscreen, toggleFullscreen } = useFullscreen();

  return (
    <Tooltip title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}>
      <IconButton
        onClick={toggleFullscreen}
        size="small"
        sx={{
          color: 'text.secondary',
          backgroundColor: 'background.paper',
          boxShadow: 1,
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </IconButton>
    </Tooltip>
  );
};
